
import cx from "classnames";
import styles from "./index.module.scss";

export default ({ className, ...rest }) => (
  <svg {...rest} className={cx(styles.main, className)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm8 1.59L16.59 7 18 8.42l-8 8-4-4 1.41-1.41L10 13.59Z"
      fill="currentColor"
    />
  </svg>
);
